import { privateRequest } from "../axios";
import type { ApiResponse } from "@/types/common";
import type {
  NotificationChannelItem,
  PaymentTaxConfig,
  UpdateNotificationChannelPayload,
  UpdatePaymentTaxPayload,
} from "@/types/settings";

const ENDPOINTS = {
  PAYMENT_TAX: "/settings/payment-tax",
  NOTIFICATIONS: "/settings/notifications",
};

const getPaymentTaxSettings = async (): Promise<PaymentTaxConfig> => {
  const response = await privateRequest.get<ApiResponse<PaymentTaxConfig>>(ENDPOINTS.PAYMENT_TAX);
  return response.data.data;
};

const updatePaymentTaxSettings = async (
  payload: UpdatePaymentTaxPayload,
): Promise<ApiResponse<PaymentTaxConfig>> => {
  const response = await privateRequest.put<ApiResponse<PaymentTaxConfig>>(ENDPOINTS.PAYMENT_TAX, payload);
  return response.data;
};

const getNotificationSettings = async (): Promise<NotificationChannelItem[]> => {
  const response = await privateRequest.get<ApiResponse<NotificationChannelItem[]>>(
    ENDPOINTS.NOTIFICATIONS,
  );
  return response.data.data ?? [];
};

const updateNotificationChannel = async (
  payload: UpdateNotificationChannelPayload,
): Promise<ApiResponse<NotificationChannelItem[]>> => {
  const response = await privateRequest.put<ApiResponse<NotificationChannelItem[]>>(
    ENDPOINTS.NOTIFICATIONS,
    payload,
  );
  return response.data;
};

const SettingsService = {
  getPaymentTaxSettings,
  updatePaymentTaxSettings,
  getNotificationSettings,
  updateNotificationChannel,
};

export default SettingsService;
